module.exports = __webpack_public_path__ + "img/banana-bk.eacead6c.svg";